const TimePickerButton = ({
  selectedHrOrMin,
  hourOrMin,
  onClick,
}: {
  selectedHrOrMin: string;
  hourOrMin: string;
  onClick: () => void;
}) => {
  // rendering custom time picker button component here
  return (
    <button
      tabIndex={-1}
      onClick={onClick}
      type='button'
      className={`block w-[50px] py-2 hover:bg-gray-300 duration-300 font-semibold ${
        selectedHrOrMin === hourOrMin
          ? 'bg-legal-dark-blue text-base-white'
          : 'text-legal-dark-blue'
      }`}
    >
      {hourOrMin}
    </button>
  );
};

export default TimePickerButton;
